import { RootState } from 'reduxStore/types';

export const getInvitationPageFilters = (state: RootState) => state?.orders.invitationPageFilters;
